export default {
  actualData: "Actual Data",
  actualDataReport: "Actual Data Report",
  actualDelivery: "Actual Delivery",
  actualDeliveryTime: "Actual<br>Delivery Time",
  actualPickup: "Actual Pickup",
  actualPlaceholder: "Search by Order ID, Customer",
  cancellationAndReturn: "Cancellation & Return",
  cancellationAndReturnReport: "Cancellation & Return Report",
  cancellationOrReturnDate: "Cancellation/Return Date",
  customer: "Customer",
  deliveredDate: "Delivered Date",
  deliveryId: "Delivery ID",
  deliveryLocation: "Delivery Location",
  deliveryPerformance: "Delivery Performance",
  deliveryPerformancePlaceholder: "Search by Order ID, Delivery ID, Status",
  deliveryPerformanceReport: "Delivery Performance Report",
  detailed: "Detailed",
  detailedOrders: "Detailed Orders",
  detailedOredersReport: "Detailed Orders Report",
  detailedPlaceholder: "Search by Order ID, Driver Name, Customer",
  downloadError: "Failed to download report",
  downloadSuccess: "Report downloaded successfully",
  driverId: "Driver ID",
  driverName: "Driver Name",
  earlyOrLateMinutes: "Early/Late<br>Minutes",
  exportAs: "Export As",
  invoiceAndPayment: "Invoice & Payment",
  invoiceAndPaymentPlaceholder: "Search by Order ID",
  invoiceAndPaymentReport: "Invoice & Payment Report",
  itemizedCosts: "Itemized Costs",
  listOfReports: "List of reports",
  onlyFourDecimalPlacesAllowed: "Only four decimal places allowed",
  paymentStatus: "Payment Status",
  pending: "Pending",
  printReport: "Print Report",
  reason: "Reason",
  reportsAndAnalytics: "Reports and Analytics",
  schedualedDate: "Scheduled Date D/T",
  schedualedDeliveryTime: "Scheduled D/T",
  scheduledPickup: "Scheduled Pickup D/T",
  sheduledDelivery: "Scheduled Delivery D/T",
  summary: "Summary",
  time: "Time",
  timePerformance: "Time Performance ",
  timePerformancePlaceholder: "Search by Order ID, Driver ID",
  timePerformanceReport: "Time Performance Report",
  totalAmountBilled: "Total Amount<br>Billed (JOD)",
};
